/**
 * TouchHover
 * @description Overrides first touch event for touch devices when interacting with top level navigation links
 *
 */
export class TouchHover {
  constructor() {
    this.navLinks = document.querySelectorAll('.navigation-link')
    this.addTouchEvents()
    this.currentActiveElement = document.activeElement
  }

  addTouchEvents() {
    this.navLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        if (e.pointerType === 'touch') {
          e.preventDefault()
          const hasHref = link.getAttribute('href')
          const hasSibling = link.nextElementSibling
          if (!hasHref || !hasSibling) return

          if (link === this.currentActiveElement) {
            link.click()
          } else {
            link.focus()
          }
          this.currentActiveElement = document.activeElement
        }
      })
    })
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const touchHover = new TouchHover()
})
